export class ValidationResult {
  path!: any;
  message!: string;

  constructor (path: string, message: string) {
    this.path = path;
    this.message = message;
  }
}
